{
  "intro": "Копии дисков ваших серверов. Снимки вы делаете сами, и они хранятся, пока вы их не удалите. Резервные копии Hetzner делает каждые сутки у серверов, где они включены. Из любой копии можно вернуть сервер к прошлому состоянию или запустить новый сервер.",
  "tabs": {
    "snapshots": "Снимки",
    "backups": "Резервные копии"
  },
  "status": {
    "creating": "Создаётся",
    "available": "Готов",
    "unavailable": "Недоступен"
  },
  "why": {
    "architecture": "образ для {{arch}}",
    "disk": "нужен диск от {{disk}}\u00a0ГБ",
    "notReady": "Копия ещё создаётся",
    "busy": "Идёт другое изменение",
    "protected": "Включена защита от удаления"
  },
  "costSnapshots": "Снимки в месяц",
  "costSnapshotsHint": "Снимки оплачиваются по фактически занятому месту, а не по размеру диска сервера. Пока снимок создаётся, его размер ещё неизвестен.",
  "costSnapshotsLine": "Снимков: {{count}}, всего {{size}} по {{price}} за ГБ",
  "costBackups": "Резервное копирование в месяц",
  "costBackupsHint": "Резервные копии оплачиваются не поштучно: включённое копирование добавляет процент к цене сервера, и в эту цену входят все его копии.",
  "costBackupsLine": "Включено у серверов: {{count}}, по {{percent}}\u00a0% от цены сервера",
  "perMonth": "{{price}}",
  "description": "Описание",
  "descriptionHint": "Чтобы потом узнать копию, например «перед обновлением PostgreSQL».",
  "descriptionPlaceholder": "Перед обновлением до версии 2",
  "labels": "Метки",
  "labelsInvalid": "Строка {{line}}: недопустимый ключ или значение.",
  "from": "Сделан с сервера",
  "belongsTo": "Сервер",
  "serverGone": "сервер удалён",
  "size": "Размер",
  "sizeHint": "Сколько места копия занимает в хранилище; по нему считается цена снимка. Ниже — какой диск нужен серверу, чтобы восстановиться из копии.",
  "disk": "для диска от {{disk}}\u00a0ГБ",
  "price": "В месяц",
  "flags": "Защита и метки",
  "protected": "Защищён",
  "created": "Создан",
  "emptySnapshots": "Снимков пока нет",
  "emptySnapshotsLead": "Сделайте снимок перед рискованным изменением: если что-то пойдёт не так, сервер можно будет вернуть к нему за несколько минут. Снимок переживёт даже удаление сервера.",
  "emptyBackups": "Резервных копий пока нет",
  "emptyBackupsLead": "Включите резервное копирование на странице сервера. Первая копия появится в ближайшее суточное окно, дальше Hetzner хранит семь последних.",
  "backupServers": "Резервное копирование по серверам",
  "backupServersLead": "Включается и отключается на вкладке «Копии и снимки» сервера.",
  "restore": "Восстановить сервер",
  "newServer": "Создать сервер из копии",
  "edit": "Изменить описание и метки",
  "editTitle": "Описание и метки",
  "saved": "Сохранено",
  "protect": "Защитить от удаления",
  "unprotect": "Снять защиту",
  "protecting": "Включаем защиту «{{name}}»",
  "unprotecting": "Снимаем защиту «{{name}}»",
  "convert": "Сохранить как снимок",
  "convertTitle": "Сохранить резервную копию как снимок?",
  "convertLead": "Копия «{{name}}» станет обычным снимком.",
  "convertKeeps": "Снимок останется, даже если сервер удалить или отключить у него резервное копирование.",
  "convertCount": "Копия перестанет входить в семь резервных копий сервера и не будет заменена следующей.",
  "convertPrice": "Снимок оплачивается отдельно по занятому месту: {{price}} в месяц.",
  "converted": "«{{name}}» сохранена как снимок",
  "chooseServer": "Выберите сервер",
  "restoreTitle": "Восстановить «{{server}}» из копии?",
  "restoreTitleNoServer": "Восстановить сервер из копии?",
  "restoreFromBackup": "Резервная копия «{{name}}» от {{date}}.",
  "restoreFromSnapshot": "Снимок «{{name}}» от {{date}}.",
  "restoreServer": "Какой сервер восстановить",
  "restoreData": "Всё, что сейчас на диске сервера {{server}}, заменится состоянием на {{date}}. Файлы и изменения, сделанные после, пропадут.",
  "restoreReboot": "Сервер перезапустится и будет недоступен несколько минут.",
  "restoreKeep": "IP-адреса, тип сервера, частные сети, файрволы и метки останутся прежними.",
  "restoreTip": "Если нынешнее состояние может понадобиться, сначала сделайте снимок сервера.",
  "restoreAction": "Восстановить",
  "restoring": "Восстанавливаем «{{server}}». Обычно это занимает несколько минут.",
  "snapshotTitle": "Сделать снимок",
  "snapshotLead": "Копия всего диска сервера в нынешнем состоянии.",
  "snapshotServer": "Сервер",
  "snapshotCreate": "Сделать снимок",
  "snapshotRunning": "Сервер продолжит работать. Чтобы получить целостную копию нагруженной базы данных, сначала завершите работу сервера.",
  "snapshotPrice": "Снимок оплачивается по занятому месту: {{price}} за ГБ в месяц.",
  "taking": "Делаем снимок «{{server}}»",
  "delete": "Удалить",
  "deleteTitle": "Удалить «{{name}}»?",
  "deleteForever": "Копия удаляется навсегда: восстановить из неё сервер будет нельзя.",
  "deleteBackupOthers": "Остальные резервные копии сервера останутся, следующая появится в обычное время.",
  "deleteSnapshotBilling": "Оплата за снимок прекратится.",
  "deleted": "«{{name}}» удалена"
}
